
import {userApi} from './user'

console.log('🛡️ LOADING: updateprivacysettings.js');


export const updatePrivacySettingsApi = userApi.injectEndpoints({
  endpoints: (builder) => ({    
    UpdatePrivacySettings: builder.mutation({

   
      query: ({payload}) => {
        console.log('🛡️ EXECUTING: UpdatePrivacySettings mutation');
        return {
          url: `/privacy`,
          method: 'POST',
          body: payload,
        };
      },
    }),

  }),
  overrideExisting: false,
})

export const { useUpdatePrivacySettingsMutation } = updatePrivacySettingsApi

